import { Outlet, Navigate, useNavigate } from "react-router-dom";
import { LoginStatus } from "./hook/checkLg";
import swal from "sweetalert";
import { useEffect } from "react";

const PrivateRoute = () => {
    const { login, checking } = LoginStatus();
    const navigate = useNavigate();

    useEffect(() => {
        if (!checking && !login) {
            swal("Vui lòng đăng nhập", "Hãy đăng nhập để tham gia trò chơi", "info")
                .then(() => {
                    navigate("/login");
                });
        }
    }, [checking, login, navigate]);

    if (checking) {
        return (
            <div className="loading">
                <div className="loader"></div>
            </div>
        );
    }

    return login ? <Outlet /> : null;
};

export default PrivateRoute;